/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityContactResult } from './MonitEntityContactResult';
import {
    MonitEntityContactResultFromJSON,
    MonitEntityContactResultFromJSONTyped,
    MonitEntityContactResultToJSON,
} from './MonitEntityContactResult';

/**
 * 
 * @export
 * @interface MonitEntityContactResponse
 */
export interface MonitEntityContactResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityContactResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityContactResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityContactResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityContactResult>}
     * @memberof MonitEntityContactResponse
     */
    results?: Array<MonitEntityContactResult>;
}

/**
 * Check if a given object implements the MonitEntityContactResponse interface.
 */
export function instanceOfMonitEntityContactResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityContactResponseFromJSON(json: any): MonitEntityContactResponse {
    return MonitEntityContactResponseFromJSONTyped(json, false);
}

export function MonitEntityContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityContactResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityContactResultFromJSON)),
    };
}

export function MonitEntityContactResponseToJSON(value?: MonitEntityContactResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityContactResultToJSON)),
    };
}

